import { openapi } from "../../openapi";

export const mediaAssetsEnhancer = openapi.enhanceEndpoints({
  endpoints: {
    // List
    getMultiplacerMediaAssets: {
      providesTags: ["MediaAssets"],
    },

    // Upload via express route (fetch) won’t auto-invalidate RTK cache.
    // So we invalidate on delete (tRPC/OpenAPI) at least.
    deleteMultiplacerMediaAssetsByKey: {
      invalidatesTags: ["MediaAssets"],
    },

    // SAS-url affects only the SAS response cache
    getMultiplacerAssetsSas: {
      providesTags: [],
    },
  },
});
